import React, { useEffect, useState } from "react";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import { Link } from "./../util/router";
import { useAuth } from "./../util/auth";
import base from "../util/base";
function CtaSection2(props) {
  const auth = useAuth();
  const [appt, setAppt] = useState();

  useEffect(() => {
    base("Users")
      .select({
        view: "Grid view",
        filterByFormula: `{Email} = '${auth.user.email}'`,
      })
      .firstPage(function (err, records) {
        if (err) {
          console.error(err);
          return;
        }
        records.forEach(function (record) {
          setAppt(record.get("Booked First Appointment"));
        });
      });
  }, [auth.user.email]);

  return (
    <>
      {appt === "No" || !appt ? (
        <Section
          bgColor={props.bgColor}
          size={props.size}
          bgImage={props.bgImage}
          bgImageOpacity={props.bgImageOpacity}
        >
          <Container>
            <Box textAlign="center">
              <SectionHeader
                title={props.title}
                subtitle={props.subtitle}
                size={4}
              />
              <Button
                component={Link}
                to={props.buttonPath}
                variant="contained"
                size="large"
                color={props.buttonColor}
              >
                {props.buttonText}
              </Button>
            </Box>
          </Container>
        </Section>
      ) : null}
    </>
  );
}

export default CtaSection2;
